import { render } from "./RulerX.vue?vue&type=template&id=d5cc5636&scoped=true&ts=true"
import script from "./RulerX.vue?vue&type=script&lang=ts"
export * from "./RulerX.vue?vue&type=script&lang=ts"

import "./RulerX.vue?vue&type=style&index=0&id=d5cc5636&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cc5636"]])

export default __exports__